import { Component, OnInit } from '@angular/core';
import {MdDialogRef} from '@angular/material';

@Component({
  selector: 'app-precio-dolar-detail-dialog',
  templateUrl: './precio-dolar-detail-dialog.component.html',
  styleUrls: ['./precio-dolar-detail-dialog.component.scss']
})
export class PrecioDolarDetailDialogComponent implements OnInit {

  public titulo = '';
  public desc = '';
  public fecha = '';
  public responsable = null;
  public validador = null;
  // se crea este dialog para evitar editar el de precios dado que generan muchos conflictos

  constructor(public dialogRef: MdDialogRef<PrecioDolarDetailDialogComponent>) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/financiera/precio-dolar-detail-dialog/precio-dolar-detail-dialog.component.ts